import moment from 'moment'
import React, { useState } from 'react'
import Countdown from 'react-countdown'
import { useTranslation } from 'react-i18next'
import { countDownLabel, countDownCheckTime, milisInDay, countDownType, milisInWeek } from '../../utils/constant'
import { momentToMilis } from '../../utils/utils'
import { AppUseSelector } from '../../redux/hooks'
import { checkStorySubmission, getStories } from '../../redux/actions/storyAction'
interface ICountdownProps {
  // level: string;
  type?: countDownType
  color?: string
}

const CountDown: React.FC<ICountdownProps> = (props: ICountdownProps) => {
  // Countdown anchored to Hong Kong time (UTC+8, no DST) to match the featured-story rotation and the daily submission quota.
  const { t } = useTranslation('dashboard')
  const { credentials, membership } = AppUseSelector(({ user }) => user)
  const level = credentials?.customFields?.level
  const currentDay = moment().utcOffset(8 * 60)
  let timeCDMilis = milisInDay - momentToMilis(currentDay)
  if (props.type === countDownType.Week && currentDay.weekday() != 7) {
    timeCDMilis = milisInWeek - currentDay.weekday() * milisInDay - momentToMilis(currentDay)
  }
  const [stopTimer, setStopTimer] = useState(true)
  const [reloadKey, setReloadKey] = useState(0)
  let typeLabel = !props.color && countDownLabel.Green

  const handle = {
    onComplete: () => {
      if (stopTimer) {
        setStopTimer(false)
        getStories({ level, plan: membership?.name })
          .then((res: any) => {
            if (res?.CTAMessage?.button !== 'Get started') {
              const storyIds = JSON.stringify(res?.data) === '{}' ? [] : res?.data?.map(({ id }) => id)
              if (storyIds?.length > 0) {
                checkStorySubmission({ storyIds })
              }
            }
          })
          .finally(() => {
            setReloadKey((prev) => prev + 1)
          })
      }
    },
  }

  const renderer = ({
    // days,
    hours,
    minutes,
    // seconds,
    formatted,
  }: {
    days: any
    hours: any
    minutes: any
    seconds: any
    formatted: any
    completed: boolean
  }) => {
    typeLabel = !props.color && countDownLabel.Green
    // Check time to render countdown color
    if (hours * 60 + minutes <= countDownCheckTime.Red) {
      typeLabel = !props.color && countDownLabel.Red
    } else if (hours * 60 + minutes <= countDownCheckTime.Orange) {
      typeLabel = !props.color && countDownLabel.Orange
    }

    // Uncoloured daily countdown sits inline in a sentence, so render plain hh:mm:ss text
    // rather than the padded boxes, which only read as a timer when they have a background.
    if (props.type === countDownType.Day && props.color) {
      return (
        <span className='countdown countdown-plain'>
          {formatted?.hours}:{formatted?.minutes}:{formatted?.seconds}
        </span>
      )
    }

    // Render a countdown
    return (
      <div className='countdown'>
        {props.type === countDownType.Week && (
          <>
            <div className='w-row block-countdown'>
              <div className='w-col count-down-text level-week'>{formatted?.days}</div>
              <div className='level-week-text'>{t('countdown.day')}</div>
            </div>
            &nbsp;
            <div className='w-row block-countdown'>
              <div className='w-col count-down-text level-week'>{formatted?.hours}</div>
              <div className='level-week-text'>{t('countdown.hour')}</div>
            </div>
            &nbsp;
            <div className='w-row block-countdown'>
              <div className='w-col count-down-text level-week'>{formatted?.minutes}</div>
              <div className='level-week-text'>{t('countdown.min')}</div>
            </div>
            &nbsp;
            <div className='w-row block-countdown'>
              <div className='w-col count-down-text level-week'>{formatted?.seconds}</div>
              <div className='level-week-text'>{t('countdown.sec')}</div>
            </div>
          </>
        )}
        {props.type === countDownType.Day && (
          <>
            <div className={`count-down-text level-${typeLabel}`}>{formatted?.hours}</div>
            &nbsp;
            <div className={`text-dots-mark text-${typeLabel}`}>:</div>&nbsp;
            <div className={`count-down-text level-${typeLabel}`}>{formatted?.minutes}</div>
            &nbsp;
            <div className={`text-dots-mark text-${typeLabel}`}>:</div>&nbsp;
            <div className={`count-down-text level-${typeLabel}`}>{formatted?.seconds}</div>
          </>
        )}
      </div>
    )
  }

  return (
    <Countdown
      key={`countdown-${reloadKey}`}
      date={Date.now() + timeCDMilis}
      renderer={renderer}
      onComplete={handle.onComplete}
    />
  )
}

export default CountDown
